// extracted by mini-css-extract-plugin
export default {"timestamp":"FrameTimestamp_timestamp__0k3ne","small":"FrameTimestamp_small__8rT94"};